export const StepErrorComponent = ({index}: {index: number}) => {
  return (
    <div className="group relative my-2 break-inside-avoid-page rounded-lg border bg-error-primary/10 p-3 md:my-6">
      <div className="not-prose relative mb-4 select-none overflow-hidden rounded-sm">
        <div className="m-0 block h-[72px] w-full rounded-md border bg-error-primary/10" />
      </div>

      <div className="flex items-start gap-3 px-2 md:gap-4 md:px-4">
        <div className="tiptap-inline-prose prose prose-sm md:prose-base whitespace-pre-line break-words leading-4 md:leading-5">
          {`${index}.`}
        </div>
        <div className="tiptap-inline-prose prose prose-sm md:prose-base w-full max-w-full whitespace-pre-line break-words leading-4 md:leading-5">
          Произошла ошибка
        </div>
      </div>
    </div>
  );
};
